export default {
    methods: {
        trimWhitespace(obj) {
            if (obj === null || obj === undefined) {
                return obj
            }

            if (typeof obj === 'string') {
                return obj.trim()
            }

            if (Array.isArray(obj)) {
                return obj.map((item) => this.trimWhitespace(item))
            }

            if (typeof obj === 'object') {
                const trimmed = {}
                for (const [key, value] of Object.entries(obj)) {
                    trimmed[key] = this.trimWhitespace(value)
                }
                return trimmed
            }

            return obj
        },
    },
}
